import { ActionEvent } from "../component/SSEButton";
import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";
import { PageResult } from "./PageResult";
import { Query } from "./Query";
import { Page } from "../component/Pagination";

export interface TypedReport {
  id: string;
  glmStudyId: string;
  tags: Array<string>;
  rawText: string;
  sentences: Array<Sentence>;
}

export interface Sentence {
  tokens: Array<Token>;
  tags: Array<string>;
}

export interface Token {
  type: string;
  text: string;
}

export default class TypedReportApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new TypedReportApi(axios);
  }

  search(page: Page, query: Query): Promise<PageResult<TypedReport>> {
    return this.client.post("/typed-reports/search", { page: page.current, size: page.size, ...query }).then((resp) => {
      return resp.data;
    });
  }

  findByStudyId(studyId: string): Promise<TypedReport[]> {
    return this.client.get("/typed-reports", { params: { studyId } }).then((resp) => resp.data);
  }

  processImport(file: File): Promise<ActionEvent> {
    return this.client
      .post("/typed-reports/import", file, { headers: { "Content-Type": "text/csv" } })
      .then((resp) => resp.data);
  }
}
